import styled from 'styled-components';
import { colors } from '../../../theme/colors';
import {
  FormContainer as Container,
  FormLabel as Label,
  FormError as ErrorText,
  formSelectSizeStyles as sizeStyles,
} from '../../sharedFormStyles';

export { Container, Label, ErrorText };

const getTextPrimary = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.primary) || (colors.text && colors.text.primary) || '#091b26';
const getTextMuted = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#999';
const getFontFamily = (props) => (props.theme && props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'inherit';

export const StyledSelect = styled.select`
  border: 1px solid ${(props) => (props.hasError ? colors.error : '#e0e0e0')};
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  background-color: ${(props) => (props.disabled ? colors.brandOffWhite : '#ffffff')};
  color: ${props => getTextPrimary(props)};
  font-family: ${props => getFontFamily(props)};
  transition: border-color 0.2s, box-shadow 0.2s;
  
  ${(props) => sizeStyles[props.size] || sizeStyles.md}

  &:hover {
    ${(props) => !props.disabled && `
      border-color: ${props.hasError ? colors.error : '#b5b5b5'};
    `}
  }

  &:focus {
    outline: none;
    ${(props) => !props.disabled && `
      border-color: ${props.hasError ? colors.error : colors.brandLightBlue};
      box-shadow: 0 0 0 3px ${props.hasError ? 'rgba(220, 53, 69, 0.25)' : 'rgba(0, 169, 255, 0.25)'};
    `}
  }

  &:disabled {
    cursor: not-allowed;
    color: ${props => getTextMuted(props)};
  }
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Select/components/SelectStyles.js